import getListings from '@api/routes/brands-api/getBrandsListings';
import * as templates from './templates';

var Bunge = Bunge || {};

Bunge.brandListings = (function($) {
    var ui = {};

    var filters = {
        'regions': 'filterRegions',
        'ingredients': 'filterIngredients',
        'channels': 'filterChannels',
        'applications': 'filterApplications'
    };

    var searchParams = {
        regions: '',
        ingredients: '',
        channels: '',
        applications: '',
    };

    function cacheUI() {
        ui.$brandsListingRegion = $('[data-region="brandsListingResults"]');
        ui.$searchWrapper = $('[data-region="searchWrapper"]');
        ui.$filters = $('[data-region="brandCardListing"] .listing__filter__dropdown-wrapper');
        ui.$loader = $('[data-control="pageLoader"]');
        ui.apiurl = ui.$brandsListingRegion.data('apiurl');
        ui.sourceid = ui.$brandsListingRegion.data('sourceid');
        ui.noResultsMsg = ui.$brandsListingRegion.data('noresultsmsg');
        ui.errorMsg = ui.$brandsListingRegion.data('errormsg');
    }

    function registerHandlers() {
        $('#-brand-card-listing .listing__filter__toggle-button').on(
            'click',
            brandsListingFilterToggle
        );
        
        $('#-brand-card-listing .listing__filter__dropdown__item input').on(
            'click',
            radioClick
        );

        $('#-brand-card-listing .listing__filter__dropdown__side-menu__buttons > button').on(
            'click', 
            toggleFilterMenu
        );

        $('#-brand-card-listing .js-reset-filters').on('click', resetFilters);
    }

    function updateURLHistory() {
        if ('URLSearchParams' in window) {
            var newSearchParams = new URLSearchParams(window.location.search);

            if (searchParams.ingredients !== '') {
                newSearchParams.set('ingredients', searchParams.ingredients);
            } else {
                newSearchParams.delete('ingredients');
            }

            if (searchParams.channels !== '') {
                newSearchParams.set('channels', searchParams.channels);
            } else {
                newSearchParams.delete('channels');
            }

            if (searchParams.applications !== '') {
                newSearchParams.set('applications', searchParams.applications);
            } else {
                newSearchParams.delete('applications');
            }

            if (searchParams.regions !== '') {
                newSearchParams.set('regions', searchParams.regions);
            } else {
                newSearchParams.delete('regions');
            }

            var newRelativePathQuery =
                window.location.pathname + '?' + newSearchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
    }

    function brandsListingFilterToggle() {
        let dropdownToggle = ui.$filters.find('.listing__filter__toggle-button');
        let currentDropdown = ui.$filters.find('.listing__filter__dropdown__container');

        if ($(currentDropdown).hasClass('-hidden')) {
            $(currentDropdown).removeClass('-hidden');
            $(dropdownToggle).addClass('active');
        } else {
            $(currentDropdown).addClass('-hidden');
            $(dropdownToggle).removeClass('active');
        }

        $('.listing__filter__dropdown').hide();
        $('.listing__filter__dropdown__container .active-button').removeClass('active-button');
    }

    function initParams() {
        const queryString = window.location.search;
        const urlParams1 = new URLSearchParams(queryString);

        Object.entries(filters).forEach(([key, value]) => {
            let attributes = $(`[data-${key}]`).attr(`data-${key}`).replace(', ',',').toLowerCase();
            if(!urlParams1.has(key) && attributes) {
                setFilterUI(value, attributes);
                eval(`searchParams.${key} = attributes`);
            }
        });
    }

    function addFilterParams(param, name) {
        let filterItems = document.querySelectorAll(`[name="${name}"]:checked`);
        let filterChoices = '';
        filterItems.forEach(function(item, index) {
            filterChoices += (item.value).toLowerCase();;
            if(index < filterItems.length - 1) {
                filterChoices += ',';
            }
        });
        eval(`searchParams.${param} = filterChoices`);
    }

    function radioClick(e) {
        let currentDropdown = e.currentTarget;
        let name = currentDropdown.name;

        Object.entries(filters).forEach(([key, value]) => {
            if (name === value) {
                addFilterParams(key, value);
            }
        });

        getBrandsListings();
        updateURLHistory();
        brandsListingFilterToggle();
    }

    function toggleFilterMenu() {
        $(this).next().toggle();
        $(this).parent().siblings().find('.listing__filter__dropdown').hide();
        if ($(this).hasClass('active-button')) {
            $('.active-button').removeClass('active-button');
        } else {
            $('.active-button').removeClass('active-button');
            $(this).addClass('active-button');
        }
    }
    
    function resetFilters() {
        $('.active-button').removeClass('active-button');
        searchParams.ingredients = '';
        searchParams.channels = '';
        searchParams.regions = '';
        searchParams.ingredients = '';
        let sideMenuRb = document.querySelectorAll(
            '.listing__filter__dropdown__side-menu__buttons input'
        );
        sideMenuRb.forEach(function(item) {
            item.checked = false;
        });
        getBrandsListings();
        updateURLHistory();
        brandsListingFilterToggle();
    }
    
    function showLoader() {
        ui.$searchWrapper.css('opacity', '.3').css('pointer-events', 'none');
        ui.$loader.show();
    }

    function hideLoader() {
        ui.$searchWrapper.css('opacity', '1').css('pointer-events', 'all');
        ui.$loader.hide();
    }

    async function getBrandsListings(updateURL) {
        let url = ui.apiurl;
        if (process.env.NODE_ENV !== 'development') {
            getListings.setRoute(url);
        }
        const { success, data, error } = await getListings.query(searchParams);
        if (!success) {
            console.log('failed', error);
            ui.$brandsListingRegion.html(ui.errorMsg);
            hideLoader();
            return;
        }
        var brandCards = '';
        if(data.brands.length === 0) {
            ui.$brandsListingRegion.html(ui.noResultsMsg);
        } else {
            $.each(data.brands, function(i, item) {
                brandCards += `${templates.brandCard({
                    title: item.title,
                    description: item.description,
                    link: item.link,
                    icon: item.icon,
                })}`;
            });
            ui.$brandsListingRegion.html(brandCards);
        }
        
        if (updateURL) {
            updateURLHistory();
        }
        hideLoader();
    }

    function setFilterUI(name, values){
        let items = document.querySelectorAll(`[name="${name}"]`);
        let nameArr = values.split(',');

        nameArr.forEach(function(filterValue) {
            items.forEach(function(item) {
                if ((item.value).toLowerCase() === (filterValue).trim().toLowerCase()) {
                    item.checked = true;
                }
            });
        });
    }

    function init() {
        if ($('[data-region="brandsListingResults"]').length <= 0) {
            return;
        }
        initParams();
        cacheUI();
        registerHandlers();
        showLoader();

        if (window.location.href.match(/\?./)) {
            const urlParams = new URLSearchParams(
                decodeURIComponent(window.location.search)
            );

            for (const [key, value] of urlParams.entries()) {
                if (key === 'regions' && value != '') {
                    setFilterUI('filterRegions', value);
                    searchParams.regions = value;
                }

                if (key === 'ingredients' && value != '') {
                    setFilterUI('filterIngredients', value);
                    searchParams.ingredients = value;
                }

                if (key === 'channels' && value != '') {
                    setFilterUI('filterChannels', value);
                    searchParams.channels = value;
                }

                if (key === 'applications' && value != '') {
                    setFilterUI('filterApplications', value);
                    searchParams.applications = value;
                }
            }
        }

        searchParams.sourceid = ui.sourceid;
        getBrandsListings(false);
    }

    return {
        init: init,
    };
})(jQuery);

$(function() {
    Bunge.brandListings.init();
});
